export enum DialogBlockInstance {
    UPGRADE = 'upgrade',
    LIMIT = 'limit',
}
